module.exports = __webpack_public_path__ + "img/play.e9b7d374.png";